import { ModalSheet, type SheetProps, type SheetSize } from "./ModalSheet";
import "./dialog.css";

type Props = SheetProps & {
  open: boolean;
  size?: SheetSize;
};

// Finestra modale al centro. Esc e il clic sul fondo chiamano `onClose`; a chiuderla è il padre,
// che smette di passare `open`. Il titolo è il nome accessibile; il focus torna a chi l'ha aperta.
export function Dialog({ open, size = "normal", ...sheet }: Props) {
  return open ? <ModalSheet kind="dialog" size={size} {...sheet} /> : null;
}
